import { type AxiosRequestConfig } from 'axios'

const deleteUserJob = (id: string): AxiosRequestConfig => {
  return {
    method: 'DELETE',
    url: '/user/info/job/item',
    params: {
      id
    }
  }
}

export { deleteUserJob }
